import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div id="id_bloc" className="container-fluid">
                    <div className="row">
                        {/* id_article_1 */}
                        <section className="col-12">
                            {/* id_article_1_inner_block */}
                            <section id="id_article_1_inner_block" className="row align-items-center">
                                <div className="col-lg-6">
                                    {/* id_article_1_image_article */}
                                    <img id="id_article_1_image_article" src="attribut_id_article_1_image_article_src" alt="attribut_id_article_1_image_article_alt" className="img-fluid" />
                                    {/* end-id_article_1_image_article */}
                                </div>
                                <div className="col-lg-6">
                                    {/* id_article_1_titre_article */}
                                    <h2 id="id_article_1_titre_article">
attribut_id_article_1_titre_article_texte
                                    </h2>
                                    {/* end-id_article_1_titre_article */}
                                    {/* id_article_1_date_article */}
                                    <p id="id_article_1_date_article">
attribut_id_article_1_date_article_texte
                                    </p>
                                    {/* end-id_article_1_date_article */}
                                    {/* id_article_1_extrait_article */}
                                    <p id="id_article_1_extrait_article">
attribut_id_article_1_extrait_article_texte
                                    </p>
                                    {/* end-id_article_1_extrait_article */}
                                    {/* id_article_1_bouton_article */}
                                    <a href="attribut_id_article_1_bouton_article_lien" id="id_article_1_bouton_article" className="btn" role="button">
                                        {/* id_article_1_bouton_article_texte_1 */}
                                        <span id="id_article_1_bouton_article_texte_1">
attribut_id_article_1_bouton_article_texte_1_texte
                                        </span>
                                        {/* end-id_article_1_bouton_article_texte_1 */}
                                    </a>
                                    {/* end-id_article_1_bouton_article */}
                                </div>
                            </section>
                            {/* end-id_article_1_inner_block */}
                        </section>
                        {/* end-id_article_1 */}
                        {/* id_article_2 */}
                        <section className="col-12">
                            {/* id_article_2_inner_block */}
                            <section id="id_article_2_inner_block" className="row align-items-center">
                                <div className="col-lg-6">
                                    {/* id_article_2_image_article */}
                                    <img id="id_article_2_image_article" src="attribut_id_article_2_image_article_src" alt="attribut_id_article_2_image_article_alt" className="img-fluid" />
                                    {/* end-id_article_2_image_article */}
                                </div>
                                <div className="col-lg-6">
                                    {/* id_article_2_titre_article */}
                                    <h2 id="id_article_2_titre_article">
attribut_id_article_2_titre_article_texte
                                    </h2>
                                    {/* end-id_article_2_titre_article */}
                                    {/* id_article_2_date_article */}
                                    <p id="id_article_2_date_article">
attribut_id_article_2_date_article_texte
                                    </p>
                                    {/* end-id_article_2_date_article */}
                                    {/* id_article_2_extrait_article */}
                                    <p id="id_article_2_extrait_article">
attribut_id_article_2_extrait_article_texte
                                    </p>
                                    {/* end-id_article_2_extrait_article */}
                                    {/* id_article_2_bouton_article */}
                                    <a href="attribut_id_article_2_bouton_article_lien" id="id_article_2_bouton_article" className="btn" role="button">
                                        {/* id_article_2_bouton_article_texte_1 */}
                                        <span id="id_article_2_bouton_article_texte_1">
attribut_id_article_2_bouton_article_texte_1_texte
                                        </span>
                                        {/* end-id_article_2_bouton_article_texte_1 */}
                                    </a>
                                    {/* end-id_article_2_bouton_article */}
                                </div>
                            </section>
                            {/* end-id_article_2_inner_block */}
                        </section>
                        {/* end-id_article_2 */}
                        {/* id_article_3 */}
                        <section className="col-12">
                            {/* id_article_3_inner_block */}
                            <section id="id_article_3_inner_block" className="row align-items-center">
                                <div className="col-lg-6">
                                    {/* id_article_3_image_article */}
                                    <img id="id_article_3_image_article" src="attribut_id_article_3_image_article_src" alt="attribut_id_article_3_image_article_alt" className="img-fluid" />
                                    {/* end-id_article_3_image_article */}
                                </div>
                                <div className="col-lg-6">
                                    {/* id_article_3_titre_article */}
                                    <h2 id="id_article_3_titre_article">
attribut_id_article_3_titre_article_texte
                                    </h2>
                                    {/* end-id_article_3_titre_article */}
                                    {/* id_article_3_date_article */}
                                    <p id="id_article_3_date_article">
attribut_id_article_3_date_article_texte
                                    </p>
                                    {/* end-id_article_3_date_article */}
                                    {/* id_article_3_extrait_article */}
                                    <p id="id_article_3_extrait_article">
attribut_id_article_3_extrait_article_texte
                                    </p>
                                    {/* end-id_article_3_extrait_article */}
                                    {/* id_article_3_bouton_article */}
                                    <a href="attribut_id_article_3_bouton_article_lien" id="id_article_3_bouton_article" className="btn" role="button">
                                        {/* id_article_3_bouton_article_texte_1 */}
                                        <span id="id_article_3_bouton_article_texte_1">
attribut_id_article_3_bouton_article_texte_1_texte
                                        </span>
                                        {/* end-id_article_3_bouton_article_texte_1 */}
                                    </a>
                                    {/* end-id_article_3_bouton_article */}
                                </div>
                            </section>
                            {/* end-id_article_3_inner_block */}
                        </section>
                        {/* end-id_article_3 */}
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}